/*
 * FormikTextField.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Sat Feb 04 2023 mys Company
 */

import { useEffect, useState } from 'react'
import uuid from 'react-uuid'

const FormikTextField = ({ label, id, name, hint, placeHolder, inputValue, inputType = 'text', inputMode = 'text', inputClassName, className, onChange, onBlur, onFocus, disabled = false, formik }) => {
    // MARK: VARIABLE
    const [uuId, setUuId] = useState()

    // MARK: METHOD
    useEffect(() => {
        setUuId(uuid())
    }, [])

    const handleChange = (e) => {
        if (onChange) onChange(e.target.value)
        // if (formik) formik.setFieldValue(name, e.target.value)
        if (formik) formik.handleChange(e)
    }

    return (
        <>
            <div className={` ${className ?? ''}`}>
                <label className={`w-100 block  text-sm `}>
                    {label} <span className={`text-xs text-gray-400 inline ${hint ? '' : 'hidden'}`}> - {hint}</span>
                </label>

                <input
                    name={name}
                    id={id ?? name + '_' + uuId}
                    className={`w-full border border-gray-100 rounded shadow-sm p-2 outline-none ${inputClassName ?? ''}`}
                    onChange={handleChange}
                    defaultValue={formik?.values[name] ?? inputValue}
                    type={inputType}
                    disabled={disabled}
                    inputMode={inputMode}
                    placeholder={placeHolder}
                    onBlur={onBlur}
                    onFocus={onFocus}
                />
            </div>
            <div className={`text-red-500 text-xs `}>{formik?.errors[name] && formik?.touched[name] ? formik?.errors[name] : null}</div>
        </>
    )
}

export default FormikTextField
